import React from "react";
import { ProductsFilter } from "./ProductsFilter";
import { AppModel } from "../../models";
import { Action } from "../../store/actions";

interface MainSearchFilterProps {
    state: AppModel;
    dispatch: (action: Action) => void;
}

export const MainSearchFilter = ({ state, dispatch }: MainSearchFilterProps) => {
    const typeChangeHandler = (id: string) => {
        dispatch({
            type: "FilterTagChanged",
            tag: id
        });
    };

    return <div className="st-main-search__filter">
        <ProductsFilter
            filterTags={state.filterTags}
            onChange={typeChangeHandler}
        />
    </div>;
};
